(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dl-product-stack"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__dlStack) return;
    window.__dlStack = true;

    function fmt(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function data(root) {
      if (!root._dl) {
        try { root._dl = JSON.parse(root.querySelector('[data-dl-stack-data]').textContent); } catch (e) { root._dl = null; }
      }
      return root._dl;
    }

    function mainVariant(root) {
      var sec = root.closest('.shopify-section') || document;
      var list = sec.querySelectorAll('variant-picker script[type="application/json"]');
      for (var i = 0; i < list.length; i++) {
        try {
          var j = JSON.parse(list[i].textContent);
          if (j && j.id && typeof j.price === 'number') return j;
        } catch (e) {}
      }
      return null;
    }

    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }

    function update(root) {
      var d = data(root);
      var mv = mainVariant(root);
      if (!d || !mv) return;
      var values = mv.options || [mv.option1, mv.option2, mv.option3];
      var fi = mv.featured_image;
      var src = fi && (typeof fi === 'string' ? fi : fi.src);
      if (src) {
        src = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      } else if (d.metalIdx > -1 && d.metalImg) {
        src = d.metalImg[values[d.metalIdx]] || null;
      }
      if (src) {
        root.querySelectorAll('[data-dl-thumb]').forEach(function (img) {
          if (img.getAttribute('src') !== src) img.setAttribute('src', src);
        });
      }
      root.querySelectorAll('.dl-stack__opt').forEach(function (opt, idx) {
        var n = idx + 1;
        var full = mv.price * n;
        var rate = n === 2 ? 0.9 : n >= 3 ? 0.85 : 1;
        var total = Math.round(full * rate);
        setText(opt.querySelector('[data-dl-total]'), fmt(total, d.currency));
        setText(opt.querySelector('[data-dl-save]'), 'Save ' + fmt(full - total, d.currency));
      });
    }

    function schedule(root) {
      clearTimeout(root._dlTimer);
      root._dlTimer = setTimeout(function () { update(root); }, 120);
    }

    function init() {
      document.querySelectorAll('[data-dl-stack]').forEach(function (root) {
        if (root._dlInit) return;
        root._dlInit = true;
        update(root);
        var sec = root.closest('.shopify-section') || document.body;
        new MutationObserver(function (records) {
          for (var i = 0; i < records.length; i++) {
            if (!root.contains(records[i].target)) { schedule(root); return; }
          }
        }).observe(sec, { subtree: true, childList: true, characterData: true });
      });
    }

    // 2 or 3 pieces: set the form quantity just before the theme reads it.
    // Listening on window (capture) runs before the theme's own submit handler.
    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var sec = form.closest('.shopify-section');
      var root = sec && sec.querySelector('[data-dl-stack]');
      if (!root) return;
      var sel = root.querySelector('.dl-stack__input:checked');
      var n = sel ? Number(sel.value) : 1;
      form.querySelectorAll('[name="quantity"]').forEach(function (q) { q.value = String(n); });
    }, true);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dl-product-videos"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var vids = Array.prototype.slice.call(root.querySelectorAll('video'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var labelOn = root.dataset.labelOn || 'Turn sound on';
      var labelOff = root.dataset.labelOff || 'Turn sound off';
      function load(v) {
        if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
      }
      function play(v) {
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
      function setState(v, on) {
        var item = v.closest('.dl-pvid__item');
        var b = item && item.querySelector('.dl-pvid__sound');
        v.muted = !on;
        if (item) item.classList.toggle('is-sound', on);
        if (b) {
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.setAttribute('aria-label', on ? labelOff : labelOn);
        }
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) {
              load(v);
              if (!reduce || !v.muted) play(v);
            } else {
              v.pause();
              if (!v.muted) setState(v, false);
            }
          });
        }, { threshold: 0.5 });
        vids.forEach(function (v) { io.observe(v); });
      } else {
        vids.forEach(load);
      }
      root.addEventListener('click', function (ev) {
        var item = ev.target.closest('.dl-pvid__item');
        if (!item) return;
        var v = item.querySelector('video');
        if (!v) return;
        load(v);
        var turnOn = v.muted;
        vids.forEach(function (o) { if (o !== v && !o.muted) setState(o, false); });
        if (turnOn) {
          setState(v, true);
          try { v.currentTime = 0; } catch (err) {}
          play(v);
        } else {
          setState(v, false);
          if (reduce) v.pause();
        }
      });
    }
    function boot() {
      document.querySelectorAll('[data-dl-pvid]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
